import { Car, PawPrint, Hourglass, Sparkles, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const ICONS = { Car, PawPrint, Hourglass, Sparkles };

const OPTIONS = [
  {
    key: "suv",
    label: "SUV",
    icon: "Car",
    desc: "Pour les véhicules de grande taille",
  },
  {
    key: "animal",
    label: "Poils d'animaux",
    icon: "PawPrint",
    desc: "Brossage, aspiration spéciale, désodorisation",
  },
  {
    key: "sable",
    label: "Sable",
    icon: "Hourglass",
    desc: "Décrassage profond des tapis et sièges",
  },
  {
    key: "tres-sale",
    label: "Véhicule très sale",
    icon: "Sparkles",
    desc: "Prestation renforcée pour intérieurs très encrassés",
  },
];

export default function Options({ onOpenBooking }) {
  return (
    <section
      id="options"
      data-testid="options-section"
      className="bg-[#F3F5F7] py-20 lg:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 reveal">
          <div className="max-w-2xl">
            <p className="text-sm uppercase tracking-[0.18em] text-[#1E88C8] font-semibold">
              Options supplémentaires
            </p>
            <h2 className="font-display text-3xl md:text-4xl text-[#0B3A5B] mt-3">
              + 10 € par option
            </h2>
            <p className="mt-4 text-base text-[#2F3438]/75 leading-relaxed">
              À combiner avec n&apos;importe quelle formule, selon l&apos;état de votre véhicule.
            </p>
          </div>
          <Button
            data-testid="options-booking-button"
            onClick={onOpenBooking}
            className="btn-press self-start lg:self-auto h-12 px-6 rounded-full bg-[#0B3A5B] hover:bg-[#0a3251] text-white font-semibold"
          >
            <CalendarCheck className="h-4 w-4 mr-2" />
            Prendre rendez-vous
          </Button>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {OPTIONS.map((o, idx) => {
            const Icon = ICONS[o.icon];
            return (
              <div
                key={o.key}
                data-testid={`option-card-${o.key}`}
                className={`reveal reveal-delay-${(idx % 3) + 1} card-lift bg-white rounded-2xl p-6 sm:p-7 border border-[#0B3A5B]/8 shadow-[0_14px_36px_-22px_rgba(11,58,91,0.22)] flex flex-col`}
              >
                <div className="h-16 w-16 rounded-2xl bg-[#1E88C8]/10 text-[#1E88C8] flex items-center justify-center">
                  <Icon className="h-8 w-8" strokeWidth={2} />
                </div>
                <h3 className="mt-5 font-display text-lg text-[#0B3A5B]">{o.label}</h3>
                <p className="mt-1.5 text-sm text-[#2F3438]/70 leading-relaxed flex-1">{o.desc}</p>
                <div className="mt-5 pt-4 border-t border-[#0B3A5B]/8 flex items-baseline gap-1.5">
                  <span className="font-display text-3xl sm:text-4xl font-bold text-[#0B3A5B]" data-testid={`option-price-${o.key}`}>
                    +10 €
                  </span>
                  <span className="text-xs text-[#2F3438]/55 uppercase tracking-wider">/ option</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
